"use client"
import { useGSAP } from "@gsap/react";
import clsx from "clsx";
import gsap from "gsap";

import { useEffect, useRef } from "react";
import { useApp } from "@/context/AppContext";

export default function OverlayTransitionWrapper({
  backgroundContent,
  overlayContent,
  mainContent,
  overlayClassName = 'absolute top-0 left-0 z-2000 overflow-hidden w-full',
  overlayInnerClassName,
}) {
  const { isInitialLoad } = useApp();
  const overlayRef = useRef(null);
  const scrollWrapperRef = useRef(null)
  const backgroundRef = useRef(null);

  useGSAP(() => {
    if (backgroundRef.current && overlayRef.current) {
      const mm = gsap.matchMedia();

      mm.add(
        {
          hasMotion: "(prefers-reduced-motion: no-preference)",
          hasNoMotion: "(prefers-reduced-motion: reduce)",
        },
        async (context) => {
          const { hasMotion } = context.conditions;

          if (hasMotion) {
            gsap.fromTo([document.documentElement.querySelector('#HeaderRegion'), document.querySelector('.main-nav'), backgroundRef.current], {
              filter: 'brightness(100%)',
            }, {
              filter: 'brightness(30%)',
              duration: 1,
              delay: 1.2,
              ease: 'expo.out'
            })
            gsap.fromTo(overlayRef.current, {
              transformOrigin: '90% 10%'
            }, {
              y: 0,
              rotate: 0,
              delay: 1.2,
              duration: 1,
              ease: 'expo.out'
            })

            gsap.to(overlayRef.current, {
              opacity: 1,
              delay: 1.2,
              duration: 0.2,
              ease: 'linear.none'
            })
          } else {
            gsap.set(overlayRef.current, {
              y: 0,
              opacity: 1,
              rotate: 0
            })
          }
        }
      )
    }
  }, [backgroundRef, overlayRef])

  useEffect(() => {
    if (isInitialLoad) {
      window.scrollTo(0, 0);
    }
  }, [isInitialLoad])

  if (isInitialLoad) {
    return (
      <div>
        <div ref={backgroundRef} inert={true} aria-hidden={true}>
          {backgroundContent}
        </div>
        <div className={overlayClassName} ref={scrollWrapperRef}>
          <div ref={overlayRef} className={clsx(' translate-y-[50vh] rotate-[-5deg] opacity-0 overflow-y-auto', overlayInnerClassName)}>
            {overlayContent}
          </div>
        </div>
      </div>
    )
  }

  return mainContent;
}
